import type { environments } from "@dealer-center/core-enviroment";
import type { RouteObject } from "react-router-dom";
import {
  PagesGvmUi,
  TrimWrapperPage,
  VehicleWrapperPage
} from "@dealer-center/inventory-pages-gvm-react";

export const gvmRoutes = (environment: environments): RouteObject => ({
  path: "gvm/*",
  children: [
    {
      index: true,
      element: <PagesGvmUi />
    },
    {
      path: "search",
      element: <PagesGvmUi />
    },
    {
      path: "vehicle",
      element: <VehicleWrapperPage />
    },
    {
      path: "trim",
      element: <TrimWrapperPage />
    },
    {
      path: "*",
      element: <PagesGvmUi />
    }
  ]
});
